import React, { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Typography, Divider } from '@material-ui/core';
import { invokePostService, toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';

export default function DeleteUser({ id, onClose, onCompletion }) {

    
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteClusterlet', { isForceDelete: true }, [id])).then(res => {   
            setLoading(false);
            if (res?.status === true) {
                onCompletion('Enterprise App Integration', 'delete');
            } else {
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
        });
    }

    return (
        <Grid container direction={"row"} spacing={1} >
            <Grid item xs={12} >
                <Typography variant="h6">Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Fragment>
                <Typography > Are you sure you want to delete the Enterprise App node? </Typography>
            </Fragment>
            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <Button color="primary" variant="outlined" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onClose}> Cancel </Button>
                <Button color="secondary" variant="contained" style={{ marginLeft: 10 , textTransform: 'capitalize' }} disabled={loading} onClick={onDelete}> {loading ? 'Deleting..' : 'Delete'} </Button>
            </Grid>

        </Grid>
    )
}
